export default __webpack_public_path__ + "static/media/webinarlogopennant.a00eff0f.png";